export default (name: string, projectId: number, vendorId?: number) => {
  return JSON.stringify({
    channel: name,
    project_id: projectId,
    ...(vendorId && { product_id: vendorId }),
  });
};
